<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>lim (n→∞) a_n = L$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 500 240">
          <!-- Horizontal Axis (n) -->
          <line x1="50" y1="200" x2="450" y2="200" stroke="#888" />
          <text x="460" y="205" fill="#888" font-size="10">n</text>
          
          <!-- Vertical Axis (a_n) -->
          <line x1="50" y1="200" x2="50" y2="20" stroke="#888" />
          
          <!-- Limit Line (L) -->
          <line x1="50" :y1="limitY" x2="450" :y2="limitY" stroke="rgba(46, 213, 115, 0.3)" stroke-dasharray="8" />
          <text x="55" :y="limitY - 5" fill="#2ed573" font-size="10">极限 L</text>

          <!-- Epsilon band -->
          <rect x="50" :y="limitY - epsilon" width="400" :height="epsilon * 2" fill="rgba(46, 213, 115, 0.05)" />
          <line x1="455" :y1="limitY - epsilon" x2="455" :y2="limitY + epsilon" stroke="#888" stroke-width="1" />
          <text x="460" :y="limitY" fill="#888" font-size="10">2ε</text>

          <!-- Sequence points -->
          <g v-for="n in 30" :key="n">
            <circle :cx="50 + n*13" :cy="calcY(n)" :r="n > threshold ? 4 : 3" :fill="n > threshold ? '#2ed573' : '#ff4757'" />
            <line v-if="n < 30" :x1="50 + n*13" :y1="calcY(n)" :x2="50 + (n+1)*13" :y2="calcY(n+1)" stroke="rgba(255,255,255,0.1)" />
          </g>

          <!-- N indicator -->
          <line :x1="50 + threshold*13" y1="20" :x2="50 + threshold*13" y2="210" stroke="#ffd700" stroke-dasharray="4" />
          <text :x="50 + threshold*13 + 5" y="30" fill="#ffd700" font-size="10">N (当 n > N 时, |a_n - L| < ε)</text>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>极限：</strong>描述数列或函数随着变量无限增大或无限接近某点时的趋势。ε-N 定义通过给定的一个精度 ε，找到一个临界项数 N，使得之后的每一项都落在 L 的 ε 邻域内。这构成了微积分的严密理论基石。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LimitViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      epsilon: 15,
      limitY: 80
    }
  },
  computed: {
    threshold() {
       // Calculation based on sequence: y = L + 100/n
       // Solve: 100/n < epsilon => n > 100/epsilon
       return Math.floor(100 / (this.epsilon * 0.5));
    }
  },
  methods: {
    calcY(n) {
       // Sequence: a_n = L + C/n with some oscillation
       const osc = Math.sin(n) * (40/n);
       const trend = 100 / n;
       return this.limitY + trend + osc;
    }
  }
}
</script>

<style scoped lang="scss">
.limit-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 10px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>